import React, { useState, useEffect, useRef } from "react";
import { func, bool, array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import SearchIcon from "../../atoms/icons/search-icon";
import Navbar from "../Navbar";
import MobileLogo from "../../atoms/MobileLogo";
import VerticalMenubar from "../VerticalMenubar";
import { setVerticalMenuBar } from "../../helper/actions";
import { useStyleMenubar, useDeviceWidth, logoRenderer } from "../../utils/react-utils";

import "./secondaryHeaderTopContent.m.css";

const SecondaryHeaderTopContent = ({
  isVerticalMenubar,
  setVerticalMenuBar,
  domainInfo,
  domainSlug = "",
  hamburgerMenu,
  navbarMenu
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const ref = useRef(null);
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  return (
    <div styleName="base">
      <div
        styleName={`wrapper  ${domainInfo && domainInfo.className ? domainInfo.className : ""}`}
        className="header-top-content"
      >
        <div>
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            <HamburgerIcon
              onMenuToggle={toggleVerticalMenubar}
              isNavbarOpen={!!isVerticalMenubar}
              isDesktop={isDesktop}
            />
            {showSearchIcon && (
              <span styleName="search-icon" onClick={toggleSearchIcon}>
                <SearchIcon domainSlug={domainSlug} color={domainSlug === "nagorik-sangbad" ? "#ffffff" : null} />
              </span>
            )}
            <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>
          </div>
          {isVerticalMenubar && (
            <VerticalMenubar
              isVerticalMenubar={isVerticalMenubar}
              isDesktop={isDesktop}
              domainInfo={domainInfo}
              toggleVerticalMenubar={toggleVerticalMenubar}
              hamburgerMenu={hamburgerMenu}
            />
          )}
        </div>
        <div styleName="logo">{logoRenderer(<MobileLogo editLogo={true} />)}</div>
        <Navbar menu={navbarMenu} />
      </div>
    </div>
  );
};

SecondaryHeaderTopContent.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  hamburgerMenu: array,
  navbarMenu: array,
  domainInfo: object,
  domainSlug: string
};

const mapStateToProps = state => ({
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
  domainSlug: get(state, ["qt", "domainSlug"])
});

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryHeaderTopContent);
